import { useState } from "react";
import { DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { Add, MinusCirlce, AddCircle } from "iconsax-react";

//import general component
import { BaseButton } from "../../../common/base-button/base-button";

//import view components
import DepositIncrement from "./deposit-increment";
import DepositDecrement from "./deposit-decrement";

//import styles
import "./wallet-dashboard.scss";

//import images
import walletImage from "../../../../assets/imgs/wallet-image.png";
import { t } from "i18next";
import BaseDialog from "../../../common/base-dialog/base-dialog";

function WalletDashboard({ userInformation, handleViewTransactionsChange }) {
    // handle modals
    const [incrementDialogOpen, setIncrementDialogOpen] = useState(false);
    const [decrementDialogOpen, setDecrementDialogOpen] = useState(false);
    // const [dialogContent, setDialogContent] = useState("decrement");
    // const [selectedCard, setSelectedCard] = useState("");
    // const [selectedCardId, setSelectedCardId] = useState(null);
    // const [refundAmount, setRefundAmount] = useState(0);

    const handleOpenIncrementDialog = () => {
        setIncrementDialogOpen(true);
    };

    const handleCloseIncrementDialog = () => {
        setIncrementDialogOpen(false);
    };
    const handleOpenDecrementDialog = () => {
        setDecrementDialogOpen(true);
        // setDialogContent("decrement");
    };
    // const handleSwitchToRefundOptions = (card, cardId, amount) => {
    //     setSelectedCard(card);
    //     setSelectedCardId(cardId);
    //     setRefundAmount(amount);
    //     setDialogContent("refund");
    // };

    const handleCloseDecrementDialog = () => {
        setDecrementDialogOpen(false);
    };

    //separate numbers with commas
    function numberWithCommas(x) {
        if (userInformation) {
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        }
    }

    return (
        <Grid className="wallet-dashboard" container item xs={12} rowGap={2} justifyContent="space-between">
            <Grid container item xs={12} md={6} rowGap={3}>
                <Grid className="wallet-dashboard__box-account-balance" container item xs={12}>
                    <Grid container item xs={5} sm={2} md={5}>
                        <img className="wallet-dashboard__dashboard-img" src={walletImage} alt=""></img>
                    </Grid>
                    <Grid container item xs={7} sm={4} md={7} direction="column" justifyContent="center">
                        <span className="wallet-dashboard__account-balance">{t("credit")}</span>
                        <span className="wallet-dashboard__amount">
                            {numberWithCommas(userInformation?.balance)} {t("currency")}
                        </span>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container item xs={12} md={6} justifyContent="center">
                <Grid container item xs={12} justifyContent="space-evenly" alignItems="center">
                    <Grid container item xs={5.5} justifyContent="center" alignItems="center" display={{ xs: "none", sm: "flex" }}>
                        <Grid container justifyContent="center" alignItems="center" flexDirection="row" display={{ xs: "none", sm: "flex" }} gap={2}>
                            <BaseButton
                                text={t("depositIncrement")}
                                handleClick={handleOpenIncrementDialog}
                                color="primary"
                                rightIcon={<AddCircle color="white" />}
                                size="large"
                                radius="radius-10"
                            />

                            <BaseButton
                                text={t("depositDecrement")}
                                handleClick={handleOpenDecrementDialog}
                                color="red"
                                rightIcon={<MinusCirlce color="white" />}
                                size="large"
                                radius="radius-10"
                            />
                        </Grid>
                        <BaseDialog open={decrementDialogOpen} handleClose={handleCloseDecrementDialog} top="45%" icon="close">
                            <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
                                <Add className="close" size="32" color="var(--teal-color-18)" onClick={handleCloseDecrementDialog} cursor="pointer" />
                            </DialogTitle>
                            <DialogContent>
                                {/* <DepositDecrement onConfirm={handleSwitchToRefundOptions} closeModal={handleCloseDecrementDialog} /> */}
                                <DepositDecrement closeModal={handleCloseDecrementDialog} />
                            </DialogContent>
                        </BaseDialog>
                        <BaseDialog open={incrementDialogOpen} handleClose={handleCloseIncrementDialog} top="45%" icon="close">
                            <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: "bold",
                                    }}
                                >
                                    {t("depositIncrement")}
                                </Typography>
                                <Add className="close" size="32" color="var(--teal-color-18)" onClick={handleCloseIncrementDialog} cursor="pointer" />
                            </DialogTitle>
                            <DialogContent>
                                <DepositIncrement closeModal={handleCloseIncrementDialog} />
                            </DialogContent>
                        </BaseDialog>
                    </Grid>
                </Grid>

                <Grid container item xs={11} justifyContent="center" alignItems="center" display={{ xs: "none", md: "flex" }}>
                    {/* <BaseButton text='انتقال با رمزارز دیجیتال (غیرفعال)' color='mustard' size='large' radius='all' rightIcon={<BitcoinConvert size="24" color="var(--light-color)" variant="Outline" />} /> */}
                </Grid>
            </Grid>

            {/* <Grid container item xs={12} display={{ xs: "flex", sm: "none" }}> */}
            {/* <BaseButton
                    text={t("transactions")}
                    color="primary"
                    size="large"
                    radius="radius-10"
                    rightIcon={<TableDocument size="32" color="var(--light-color)" variant="Outline" />}
                    handleClick={() => handleViewTransactionsChange(true)}
                /> */}
            {/* </Grid> */}
        </Grid>
    );
}

export default WalletDashboard;
